import { COL_SIZE, COL_SPACING, GRAY_LIGHTER } from './variables';

export const container = () => `
  width: 100%;
  margin: 0 auto;
  max-width: 1170px;
  padding: 0px 15px;
  * {
    font-family: 'Open Sans', serif;
  }
`;

export const flexPosition = ({ align = '', justify = '' }) => `
  display: flex;
  ${align && `align-items: ${align};`}
  ${justify && `justify-content: ${justify};`}
`;

export const fontStyle = (color, fontSize, fontWeight) => `
  font-family: 'Open Sans', serif;
  ${color && `color: ${color};`}
  ${fontSize && `font-size: ${fontSize};`}
  ${fontWeight && `font-weight: ${fontWeight};`}
`;

export const getColSize = (colSize = 1) => {
  let col = colSize < 0 ? 1 : colSize;
  col = colSize > 12 ? 12 : colSize;
  const spacing = colSize === 1 ? COL_SPACING : COL_SPACING * (colSize - 1);
  return `${col * COL_SIZE + spacing}px`;
};

export const customScrollbar = () => `
  &::-webkit-scrollbar-track {
    border-radius: 3px;
    background-color: #fff;
  }

  &::-webkit-scrollbar {
    width: 6px;
    background-color: #fff;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: ${GRAY_LIGHTER};
  }
`;

export const clearFix = () => `
  content: "";
  clear: both;
  display: table;
`;



// WEBPACK FOOTER //
// ./src/styles/mixins.js